/**
 * @generated SignedSource<<de427b14b021f437c691658a6b261f68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlaceSearchFieldQuery$variables = {
  query: string;
};
export type PlaceSearchFieldQuery$data = {
  readonly searchPlaces: ReadonlyArray<{
    readonly displayName: string | null;
    readonly formattedAddress: string | null;
    readonly id: string;
  }>;
};
export type PlaceSearchFieldQuery = {
  response: PlaceSearchFieldQuery$data;
  variables: PlaceSearchFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "Place",
    "kind": "LinkedField",
    "name": "searchPlaces",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "formattedAddress",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PlaceSearchFieldQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlaceSearchFieldQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a599786b27af01f026f27e4fe161bed3",
    "id": null,
    "metadata": {},
    "name": "PlaceSearchFieldQuery",
    "operationKind": "query",
    "text": "query PlaceSearchFieldQuery(\n  $query: String!\n) {\n  searchPlaces(query: $query) {\n    id\n    displayName\n    formattedAddress\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1ac00f9f38ffab26f05ca8e9f05243c";

export default node;
